import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MENU } from "../../../constants/menu";
import { Link, useNavigate } from "react-router-dom";
import MyButton from "../../../components/MyButton";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthProvider";
import { useBoardItem } from "../../../hooks/useBoardItem";
import {
  checkRoleAndPermissions,
  getPermissionMessage,
} from "../../../components/CheckRoleAndPermission";
import {
  BOARD_PERMISSION,
  NON_MEMBER_PERMISSIONS,
} from "../../../constants/permission";

const MainSidebar = ({ setOpenSidebar, openSidebar }) => {
  const navigate = useNavigate();
  const { isAuthenticated, isAdmin, setProfile, roleCode } =
    useContext(AuthContext);
  const { boards } = useBoardItem();

  const needAuthenticated = (e, menu) => {
    if (menu.to.includes("/Research") && !isAuthenticated) {
      alert("연구자 로그인 후 사용하실 수 있습니다.");
      e.preventDefault();
    } else if (
      menu?.boardCode &&
      !checkRoleAndPermissions(
        roleCode,
        boards[menu.boardCode],
        BOARD_PERMISSION.ACCESS,
        NON_MEMBER_PERMISSIONS[menu.boardCode],
        isAdmin
      )
    ) {
      alert(getPermissionMessage(BOARD_PERMISSION.ACCESS));
      e.preventDefault();
    }
  };

  const onLogout = () => {
    setProfile({});
    localStorage.removeItem("accessToken");
    if (!localStorage.getItem("isRememberId")) {
      localStorage.removeItem("rememberId");
    }
    localStorage.removeItem("refreshToken");

    navigate("/");
  };

  return (
    <div
      className={`fixed top-0 right-0 z-[101] ${
        openSidebar ? "open w-screen h-screen" : ""
      }`}
      id="main-sidebar"
    >
      <div
        className="absolute w-screen h-screen top-0 left-0 z-[101] background"
        style={{
          background: "rgba(0,0,0,0.7)",
        }}
        onClick={() => setOpenSidebar(false)}
      />
      <div className="w-screen lg:w-[320px] h-screen bg-white absolute top-0 right-0 z-[102] main-content">
        <div className="h-16 flex items-center">
          <div className="width lg:px-4 flex justify-between items-center gap-4">
            <Link className="flex items-center gap-4" to="/">
              <img
                src="/assets/img/clogo.png"
                alt="main logo"
                className="w-[130px]"
              />
            </Link>

            <button
              className="h-8 w-8 flex items-center justify-center"
              onClick={() => setOpenSidebar(false)}
            >
              <FontAwesomeIcon icon={faClose} size="xl" />
            </button>
          </div>
        </div>

        {!isAuthenticated ? (
          <div className="flex gap-3 px-4 my-5">
            <MyButton
              variant="outlined"
              size="small"
              textColor="#111111"
              className="flex-1"
              onClick={() => navigate("/Login")}
            >
              Login
            </MyButton>
            <MyButton
              variant="outlined"
              size="small"
              textColor="#111111"
              className="flex-1"
              onClick={() => navigate("/Register")}
            >
              Register
            </MyButton>
          </div>
        ) : (
          <div className="flex gap-3 px-4 my-5">
            <MyButton
              variant="outlined"
              size="small"
              textColor="#111111"
              className="flex-1 text-sm"
              onClick={() => navigate("/MyPage")}
            >
              MyPage
            </MyButton>
            {isAdmin && (
              <MyButton
                variant="outlined"
                size="small"
                textColor="#111111"
                className="flex-1 text-sm"
                onClick={() => {
                  window.open("/admin", "_blank");
                }}
              >
                Admin
              </MyButton>
            )}
            <MyButton
              variant="outlined"
              size="small"
              textColor="#111111"
              className="flex-1 text-sm"
              onClick={onLogout}
            >
              Logout
            </MyButton>
          </div>
        )}

        <ul
          className="flex flex-col pb-5 small-scroll"
          style={{
            overflowY: "auto",
            maxHeight: "calc(100vh - 180px)",
          }}
        >
          {MENU.map((item) => (
            <li key={item.id} className="border-b border-gray-border relative">
              <input
                type="radio"
                id={`menu-${item.id}`}
                name="menu-radio"
                className="hidden peer"
              />
              <label
                htmlFor={`menu-${item.id}`}
                className="p-4 cursor-pointer block text-center transition-all duration-300 ease-in-out text-gray-dark font-medium peer-checked:bg-primary peer-checked:text-white"
              >
                {item.title}
              </label>

              {item?.items?.length > 0 && (
                <ul className="text-center transition-all duration-300 ease-in-out max-h-0 overflow-hidden peer-checked:max-h-[2000px] peer-checked:block">
                  {item.items.map((c) => (
                    <li key={c.id}>
                      <Link
                        onClick={(e) => needAuthenticated(e, c)}
                        className="block text-center p-3 text-sm text-gray-dark hover:bg-[#f0f0f0]"
                        to={c.to}
                      >
                        {c.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MainSidebar;
